import { defineComponent as s, resolveComponent as i, openBlock as e, createElementBlock as p, mergeProps as r, renderSlot as o, createBlock as a, withCtx as l } from "vue";
import { _ as f } from "./_plugin-vue_export-helper.dad06003.js";
const h = s({
  name: "app-link-comp",
  inheritAttrs: !1,
  props: {
    to: {
      type: [String, Object],
      required: !0
    }
  },
  computed: {
    href() {
      return typeof this.to == "string" ? this.to : "";
    },
    isExternalLink() {
      return typeof this.to == "string" && this.to.startsWith("http");
    }
  }
}), m = ["href"];
function c(t, u, k, d, _, $) {
  const n = i("router-link");
  return t.isExternalLink ? (e(), p("a", r({ key: 0 }, t.$attrs, {
    href: t.href,
    target: "_blank"
  }), [
    o(t.$slots, "default")
  ], 16, m)) : (e(), a(n, r({ key: 1 }, t.$attrs, { to: t.to }), {
    default: l(() => [
      o(t.$slots, "default")
    ]),
    _: 3
  }, 16, ["to"]));
}
const C = /* @__PURE__ */ f(h, [["render", c]]);
export {
  C as AppLinkComp
};
//# sourceMappingURL=AppLinkComp.js.map
